var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"class-binding"},[_c('div',{class:{ active: _vm.isActive }},[_vm._v("文字の色が変わります！")]),_c('button',{on:{"click":_vm.changeActive}},[_vm._v("色をチェンジ")])])}
var staticRenderFns = []

export { render, staticRenderFns }